import { AddCircle, CalendarMonth, Description, Home, MonitorHeart, AssignmentTurnedIn } from "@mui/icons-material";
// LibraryBooks

export const HOME = 'HOME'
export const APPOINTMENTS = 'APPOINTMENTS'
export const EHR = 'EHR'
export const VITALS = 'VITALS'
export const DOCUMENTS = 'DOCUMENTS'
export const TASKS = 'TASKS'

export const ROUTER_OBJECT = [
    {
        label: 'tooltips.DASHBOARD',
        Icon: Home,
        identifier: HOME,
        path: '/home/dashboard'
    },
    {
        label: 'tooltips.APPOINTMENTS',
        Icon: CalendarMonth,
        identifier: APPOINTMENTS,
        // path: '/appointments/upcoming',
        path: '/appointments/recent',
        className:'step-3'
    },
    {
        label: 'tooltips.EHR',
        Icon: AddCircle,
        identifier: EHR,
        path: '/ehr/personal_info',
        className:'step-4'
    },
    {
        label: 'ehr.tabs.VITALS',
        Icon: MonitorHeart,
        identifier: VITALS,
        path: '/vitals/view',
        className:'step-5'
    },
    {
        label: 'documents.DOCUMENTS',
        Icon: Description,
        identifier: DOCUMENTS,
        path: '/documents/view',
        className:'step-6'
    },
    {
        label: 'tasks.TASKS',
        Icon: AssignmentTurnedIn,
        identifier: TASKS,
        path: '/tasks/requested',
        className:'step-7'
    }
]

export const getPathNames = () => {
    return window.location.pathname.split('/')
}